import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { CurrencyDollar } from "@phosphor-icons/react";

const toDollars = (m) => (m == null ? null : (m / 100).toFixed(2));

export default function ResellerPricing() {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/billing/customer-price");
        setPrice(data.standard_customer_price_minor);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const dollars = toDollars(price);

  return (
    <div className="space-y-6" data-testid="reseller-pricing-page">
      <PageHeader title="Pricing"
        subtitle="The standard per-concurrent-channel Customer price set by the platform admin. Apply it as 'Standard' when adding a customer, or enter a custom price." />
      {loading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : (
        <Card className="p-6 rounded-xl border-border max-w-md" data-testid="customer-price-card">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent grid place-items-center shrink-0">
              <CurrencyDollar className="w-5 h-5 text-primary" weight="duotone" />
            </div>
            <div>
              <h3 className="font-semibold text-base">Customer Concurrent Call Price</h3>
              <p className="text-sm text-muted-foreground mt-0.5">Standard price per concurrent channel.</p>
              <p className="text-3xl font-bold mt-3 tabular-nums" data-testid="customer-price-value">
                {dollars == null ? "Not set" : `$${dollars}`}
                {dollars != null && <span className="text-base font-normal text-muted-foreground"> / channel</span>}
              </p>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
}
